export const iconFontAwesomeFoodBeverageWheatAwn = (
	<i className="fa-solid fa-wheat-awn"></i>
);
